export function isMobile(): boolean {
    return window.innerWidth <= 768; // O cualquier otro valor que consideres para el tamaño móvil
}